import { Link } from 'react-router-dom';
export default function Contact() {
  return <section id="contact-us" className="studio-contact"><div className="studio-shell contact-layout">
    <div><p className="studio-eyebrow">Let's make work easier</p><h2>Show us the work<br />you'd like to simplify.</h2><p>Tell us what your team does today and which part takes too long. Include the tools you use so we can prepare a relevant demo.</p><p className="contact-location">For business owners, founders and operations teams in Singapore and Thailand.</p></div>
    <Link to="/#request-demo" className="contact-action"><span aria-hidden="true">↗</span>Request a demo</Link>
  </div></section>;
}
